// Projetos de eventos da Workwell (Wellbeing Games, Wellbeing Awards): a venda a um cliente é um projeto do tipo do evento,
// sem fases nem follow-ups automáticos, ligado ao evento do Marketing, onde fica como receita prevista
// até a fatura chegar (faturada) e ser paga (recebida).
export const TIPOS_EVENTO = ['Wellbeing Games', 'Wellbeing Awards'];
export const ehEvento = (tipo) => TIPOS_EVENTO.includes(tipo);

export const tipoReceitaDe = (t) => /espa[cç]o|stand/i.test(t || '') ? 'Espaço empresa'
  : /patroc|sponsor/i.test(t || '') ? 'Patrocínio' : /fee|food ?zone|expositor/i.test(t || '') ? 'Fee' : 'Bilheteira';

// tipo de evento a partir do texto de uma linha / serviço vendido
export const tipoEventoDe = (t) => /wellbeing games|\bwbg\b/i.test(t || '') ? 'Wellbeing Games'
  : /wellbeing awards|\bwba\b|gala/i.test(t || '') ? 'Wellbeing Awards' : null;

// edição ativa do evento no Marketing (a mais recente não concluída cujo nome tem «Games» / «Awards»)
export function eventoAtivo(eventos, tipo) {
  const chave = tipo === 'Wellbeing Games' ? /games/i : tipo === 'Wellbeing Awards' ? /awards/i : null;
  if (!chave) return null;
  return (eventos || []).filter(e => e.ativo !== false && chave.test(e.nome || '') && !/conclu/i.test(e.estado || ''))
    .sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')))[0] || null;
}

// cria/atualiza a receita prevista do projeto no evento (identificada por «projeto <id>» na descrição)
export async function sincronizarReceita(supabase, p) {
  try {
    if (!p || !p.id) return;
    const marca = `projeto ${p.id}`;
    const { data: ex } = await supabase.from('marketing_movimentos').select('id,fatura_id,projeto_id').eq('tipo', 'receita').like('descricao', `%${marca}%`);
    const atual = (ex || [])[0];
    const valor = Math.round((Number(p.value) || 0) * 100) / 100;
    if (!p.marketing_projeto_id || !ehEvento(p.project_type) || valor <= 0) {
      if (atual && atual.fatura_id == null) await supabase.from('marketing_movimentos').delete().eq('id', atual.id);
      return;
    }
    const linha = {
      projeto_id: p.marketing_projeto_id, tipo: 'receita', parceiro: p.client || null, valor,
      data: p.billing_month ? String(p.billing_month).slice(0, 7) + '-01' : (p.contract_start || null),
      descricao: `${p.name || ''} · ${marca}`.slice(0, 300),
    };
    if (atual) {
      if (atual.fatura_id != null) return;              // já faturada: manda a fatura
      await supabase.from('marketing_movimentos').update(linha).eq('id', atual.id);
    } else {
      await supabase.from('marketing_movimentos').insert({ ...linha, rubrica: tipoReceitaDe(p.name), estado: 'previsto', autor_nome: 'HUB (projeto)' });
    }
  } catch (e) { console.error('receita do evento:', e); }
}
